import React from 'react';
import { Divider, Flex } from '@chakra-ui/react';
import { useAccount } from '#contexts/account';

import { InstallationCell } from './InstallationCell';
import { OrganizationsHeader } from './OrganizationsHeader';
import { ScrollableTable } from './ScrollableTable';
import { useStartInstallation, useRefreshInstallations } from '../hooks';

const InstallationWrapper = ({ children, ...props }) => (
  <Flex
    role="row"
    flexDirection="column"
    {...props}
  >
    {children}
    <Divider />
  </Flex>
);

export const OrganizationsList = ({
  selectedOrganization,
  onSelectOrganization,
  ...props
}) => {
  const { installations, refetch, loading: loadingAccount } = useAccount();

  const { trigger: startInstallation } = useStartInstallation();
  const { trigger: refreshInstallations, loading: loadingRefresh } = useRefreshInstallations({
    onCompleted: () => refetch(),
  });
  const refreshingInstallations = loadingAccount || loadingRefresh;
  const showLoading = !installations?.length && loadingAccount;
  const testID = props['data-testid'];

  return (
    <Flex
      width="full"
      flexDirection="column"
      maxHeight="30rem"
      minHeight="25rem"
      {...props}
    >
      <OrganizationsHeader
        refreshingInstallations={refreshingInstallations}
        onAddInstallation={startInstallation}
        onRefreshInstallations={refreshInstallations}
      />
      <Divider />
      <ScrollableTable>
        {showLoading && (
          <InstallationWrapper>
            <InstallationCell
              data-testid={testID ? `${testID}.EmptyInstallation` : null}
            />
          </InstallationWrapper>
        )}
        {installations?.map((installation) => (
          <InstallationWrapper key={installation.id}>
            <InstallationCell
              installation={installation}
              isSelected={selectedOrganization?.id === installation.profile.id}
              refetchInstallation={refetch}
              onClick={(inst) => onSelectOrganization(inst.profile)}
            />
          </InstallationWrapper>
        ))}
      </ScrollableTable>
    </Flex>
  );
};
